import { SSO_PROVIDERS } from '@/constants/ssoProviders'
import { cn } from '@/lib/utils'

import { SsoProviderButton } from './SsoProviderButton'

interface Props {
  inviteToken?: string
  className?: string
}

export const SsoProvidersList = ({ inviteToken, className }: Props) => {
  if (SSO_PROVIDERS.length === 0) return null
  return (
    <div className={cn('flex w-full flex-col gap-3', className)}>
      {SSO_PROVIDERS.map((provider) => (
        <SsoProviderButton
          key={provider.id}
          providerId={provider.id}
          inviteToken={inviteToken}
        />
      ))}
    </div>
  )
}

export default SsoProvidersList
